/**
 * MapNorthAxis enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file MapNorthAxis.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum MapNorthAxis {
  NORTH = 0,
  EAST = 1,
  SOUTH = 2,
  WEST = 3,
};
